import PropTypes from "prop-types"
import React, { useEffect } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Alert,
  FormFeedback,
} from "reactstrap"
import Select from "react-select"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// action
import { registerUser, apiError, registerUserFailed } from "../../store/actions"

// Redux
import { connect, useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import QwikForm from "components/form/QwikForm"
import QwikInput from "components/form/QwikInput"
import { yupResolver } from "@hookform/resolvers/yup"
import { validationRegisterSchema } from "schemas/userInfoValidation"
import hashPassword from "utils/hashPassword"
import QwikSelect from "components/form/QwikSelect"
import { roleOptions } from "selectOptions/roleOptions"
import { useUserRegisterMutation } from "store/features/auth/authManagementApi"
import { useGetAllUsersQuery } from "store/features/user/userManagementApi"
import { toast } from "sonner"

const Register = props => {
  const navigate = useNavigate()
  const [createUser, { isLoading, isSuccess, isError }] =
    useUserRegisterMutation()
  const { user } = props

  const submit = async data => {
    const hashedPassword = await hashPassword(data.password)
    const registrationData = {
      nickname: data.nickname,
      personal_email: data.email,
      password_hash: hashedPassword,
      role: data.role,
    }
    const result = await createUser(registrationData)
    if (result?.data?.id) {
      toast.success("User registered successfully")
      navigate("/login")
    }
  }
  document.title = "Register | Qwik IT Services"
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">Register Now</h5>
                    <p className="text-white-50">
                      Register in to continue to Qwik IT Services.
                    </p>
                    <Link to="/index" className="logo logo-admin">
                      <img src={logoSm} height="50" alt="logo" />
                    </Link>
                  </div>
                </div>
                <CardBody className="p-4">
                  <div className="p-3">
                    {user ? (
                      <Alert
                        color="success"
                        style={{ marginTop: "13px" }}
                        className="mt-5"
                      >
                        Register User Successful
                      </Alert>
                    ) : null}
                    <QwikForm
                      onSubmit={submit}
                      resolver={yupResolver(validationRegisterSchema)}
                      className="mt-4"
                    >
                      <div className="mb-3">
                        <QwikSelect
                          name="role"
                          label="Select Role"
                          options={roleOptions}
                          placeholder="Select role"
                        />
                      </div>
                      <div className="mb-3">
                        <QwikInput
                          name="nickname"
                          label="Name"
                          placeholder="Enter Name"
                          type="text"
                          className="form-control"
                        />
                      </div>
                      <div className="mb-3">
                        <QwikInput
                          name="email"
                          label="Email"
                          placeholder="Enter Email"
                          type="email"
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3">
                        <QwikInput
                          name="password"
                          label="Password"
                          placeholder="Enter Password"
                          type="password"
                        />
                      </div>

                      <div className="mb-3 row">
                        <div className="col-sm-6">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={isLoading}
                          >
                            {isLoading ? "Registering..." : "Register"}
                          </button>
                        </div>
                      </div>
                    </QwikForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-3 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} By Qwik IT Services</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Register.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(Register)
